module.exports = __webpack_public_path__ + "static/media/military_tech.3d177063.svg";